import { analyticsStoreEvent } from 'mk2/actions';
import { homepageUrl } from 'mk2/apps/home/urls';
import GetPlus from 'mk2/apps/plan/containers/GetPlus/GetPlus';
import { getPlusFetchTrigger } from 'mk2/apps/plan/containers/GetPlus/GetPlus.actions';
import reducer from 'mk2/apps/plan/containers/GetPlus/GetPlus.reducers';
import saga from 'mk2/apps/plan/containers/GetPlus/GetPlus.sagas';
import { getGetPlusState } from 'mk2/apps/plan/containers/GetPlus/GetPlus.selectors';
import { PriceListItem } from 'mk2/apps/plan/schemas';
import { AppName } from 'mk2/containers/Application/Application';
import { MapDispatchToPropsObject } from 'mk2/helpers/types';
import Page, { BrandingProps, PageLayout } from 'mk2/pages/Page';
import { getRequestDeviceMobile, getRequestPermissions, getRequestUser, AppState } from 'mk2/reducers';
import { LoadingState } from 'mk2/reducers/loadingState';
import { UserEntity, UserSchema } from 'mk2/schemas';
import { getDenormalizedEntities } from 'mk2/selectors';
import { Store } from 'mk2/store/configureStore';
import React from 'react';
import { MapStateToPropsParam } from 'react-redux';
import { RouteComponentProps } from 'react-router';

interface OwnProps {
}

interface StateProps {
    allowPayments: boolean;
    avatars: UserEntity[];
    bazaarPlusId: number;
    errorMessage: string;
    isMobile: boolean;
    loadingState: LoadingState;
    paymentVS: string;
    planIsActiveAndDisplaying: boolean;
    plusPrices: PriceListItem[];
    requestUser: UserEntity;
    requestUserPermissions: string[];
}

interface DispatchProps {
    onLoad(src?: string);
    onStoreEvent(name: string, props: any);
}

type RouteProps = RouteComponentProps<{}>;

export type Props = OwnProps & StateProps & DispatchProps & RouteProps;

export default class GetPlusPage extends Page<OwnProps & RouteProps, StateProps, DispatchProps> {

    public mapStateToProps(): MapStateToPropsParam<StateProps, OwnProps, AppState> {
        return (state: AppState, ownProps: OwnProps): StateProps => {
            const getPlusPageState = getGetPlusState(state);
            const avatars = getDenormalizedEntities<UserEntity>(state, UserSchema, getPlusPageState.avatars);
            return {
                allowPayments: getPlusPageState.allowPayments,
                avatars,
                bazaarPlusId: getPlusPageState.bazaarPlusId,
                errorMessage: getPlusPageState.errorMessage,
                isMobile: getRequestDeviceMobile(state),
                loadingState: getPlusPageState.loadingState,
                paymentVS: getPlusPageState.paymentVS,
                planIsActiveAndDisplaying: getPlusPageState.planIsActiveAndDisplaying,
                plusPrices: getPlusPageState.plusPrices,
                requestUser: getRequestUser(state),
                requestUserPermissions: getRequestPermissions(state),
            };
        };
    }

    public mapDispatchToProps(): MapDispatchToPropsObject<DispatchProps> {
        return {
            onLoad: getPlusFetchTrigger,
            onStoreEvent: analyticsStoreEvent,
        };
    }

    public getMetaTitle(props: Props): string {
        return null;
    }

    public render(props: Props): false | JSX.Element {
        return (
            <GetPlus {...props} />
        );
    }

    public hasHeaderBackButton(props: Props): boolean {
        return true;
    }

    public getDefaultBackPath(props: Props): string {
        return homepageUrl;
    }

    public getPageLayout(app: AppName, props: Props): PageLayout {
        return PageLayout.MainContent;
    }

    public getBrandingProps(props: Props): BrandingProps {
        return null;
    }

    public registerInStore(store: Store<AppState>) {
        store.injectReducer('containers.plan.getPlus', reducer);
        store.injectSaga('containers.plan.getPlus', saga);
    }
}
